export default __webpack_public_path__ + "static/media/textlayer_size.8798561e.jpg";